import ApiService from "../../../core/services/ApiService";

export interface TierDto {
  tierLevel: number;
  entityId: number;
  entityName: string;
  partnerCount: number;
  projectId: number | null;
  projectStatus: string | null;
  // BE sends these as `status` and `outputAvailable` — kept for direct BE mapping
  status?: string | null;
  outputAvailable?: boolean;
  completedCalcs: number;
  totalCalcs: number;
  hasK1Output: boolean;
  flowStatus: "Pending" | "Flowing" | "Complete" | null;
  flowRowCount: number | null;
}

export interface FlowItemDto {
  fromEntityId: number;
  toEntityId: number;
  status: string;
  rowCount: number;
}

export interface CascadeFlowDto {
  partnershipName: string;
  partnershipId: string;
  taxYear: string;
  totalTiers: number;
  tiers: TierDto[];
  flows?: FlowItemDto[];
}

class CascadeService extends ApiService {
  async getCascadeFlow(partnershipId: string, taxYear: string): Promise<CascadeFlowDto> {
    return this.makeRequest<CascadeFlowDto>(
      `/api/cascade/flow?partnershipId=${partnershipId}&taxYear=${encodeURIComponent(taxYear)}`,
      { extractData: true },
    );
  }

  async runCalculation(projectId: number): Promise<void> {
    return this.makeRequest<void>(
      `/api/calculations/run/${projectId}`,
      { method: "POST", extractData: true },
    );
  }

  async getProjectStatus(projectId: number): Promise<{ status: string }> {
    return this.makeRequest<{ status: string }>(
      `/api/project/${projectId}/status`,
      { extractData: true },
    );
  }

  async executeFlow(partnershipId: string, taxYear: string): Promise<void> {
    return this.makeRequest<void>(
      `/api/cascade/execute`,
      { method: "POST", data: { partnershipId, taxYear }, extractData: true },
    );
  }
}

export const cascadeService = new CascadeService();
